/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/*
 * Judge.me card score formatter ("4.8/5" on product cards)
 *
 * Performance fix (Oct 2026): the previous version rewrote the badge text and
 * re-added the "has-score" class on every pass, even when nothing had changed.
 * Those writes counted as page changes, which re-triggered its own observer
 * on the next frame — an endless loop that also kept waking the PharmaBoost
 * questionnaire script. Now it only writes when the value actually differs,
 * and only reacts to changes that involve Judge.me badges.
 */
(function () {
  function formatJudgeMeCardScores(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll('.product-item__info .jdgm-prev-badge[data-average-rating]');

    badges.forEach(function (badge) {
      var rating = parseFloat(badge.getAttribute('data-average-rating'));
      if (!(rating > 0)) return;

      var label = rating.toFixed(1).replace(/\.0$/, '') + '/5';

      var textEl = badge.querySelector('.jdgm-prev-badge__text');
      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'jdgm-prev-badge__text';
        badge.appendChild(textEl);
      }

      // Only write when different — an identical write still counts as a page change.
      if (textEl.textContent !== label) textEl.textContent = label;

      var wrap = badge.closest('.product-item__rating');
      if (wrap && !wrap.classList.contains('has-score')) wrap.classList.add('has-score');
    });
  }

  var scheduled = false;
  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      formatJudgeMeCardScores(root || document);
    });
  }

  schedule();
  document.addEventListener('DOMContentLoaded', function () {
    schedule();
  });
  window.addEventListener('load', function () {
    schedule();
  });
  document.addEventListener('jdgm.doneInitializing', function () {
    schedule();
  });

  // Only react to changes that could add, redraw or re-rate a Judge.me badge.
  function involvesBadge(m) {
    if (m.type === 'attributes') return true; // attributeFilter limits this to data-average-rating
    var t = m.target;
    if (t && t.nodeType === 1 && t.closest && t.closest('.jdgm-prev-badge')) return true;
    for (var i = 0; i < m.addedNodes.length; i++) {
      var n = m.addedNodes[i];
      if (n.nodeType !== 1) continue;
      if (n.matches && n.matches('.jdgm-prev-badge')) return true;
      if (n.querySelector && n.querySelector('.jdgm-prev-badge')) return true;
    }
    return false;
  }

  function startObserver() {
    var target = document.getElementById('MainContent') || document.body;
    if (!target || !window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (involvesBadge(mutations[i])) {
          schedule();
          return;
        }
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-average-rating'],
    });
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver);
  }
})();
